export default "__VITE_ASSET__Xh6bcjfw__"